// extracted by mini-css-extract-plugin
export default {"collapse":"AdditionalSettings_collapse__pCGxv"};